import Axios, { AxiosError, AxiosResponse } from "axios";
import { PRODUCT_API_BASE_URL } from "@configs";

export const AmityProductAxios = Axios.create({
  baseURL: PRODUCT_API_BASE_URL,
});

AmityProductAxios.interceptors.response.use(
  (response: AxiosResponse) => {
    return response.data;
  },
  (error: AxiosError) => {
    return Promise.reject(error.response?.data);
  }
);
